module.exports = __webpack_public_path__ + "wallpaper6.760f56dcb053cacdc045.jpg";


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/Techbotz-master/src/assets/images/wallpaper6.jpg
// module id = ../../../../../src/assets/images/wallpaper6.jpg
// module chunks = styles